import _Promise from 'babel-runtime/core-js/promise';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import { genericServerErrorStore } from '../service/GenericServerErrorStore';

export var GeneralErrorsInterceptor = function () {
  function GeneralErrorsInterceptor() {
    _classCallCheck(this, GeneralErrorsInterceptor);
  }

  _createClass(GeneralErrorsInterceptor, null, [{
    key: 'passthrough',
    value: function passthrough(response) {
      return response;
    }
  }, {
    key: 'genericErrorsHandler',
    value: function genericErrorsHandler(error) {
      if (error.response && error.response.status === 500 && error.response.data === 'Generic Server Error') {
        genericServerErrorStore.state.setGlobalError(true);
      }
      return _Promise.reject(error);
    }
  }]);

  return GeneralErrorsInterceptor;
}();


// WEBPACK FOOTER //
// ./src/interceptors/GeneralErrorsInterceptor.js